import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

// Material-UI
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

const SignInPage = () => (
  <div className="Container-box">
    <Card className="Card">
      <SignInForm />
      
    </Card>
  </div>
);

const INITIAL_STATE = {
  email: '',
  emailError: false,
  emailErrorText: 'ex. email@sample.co',
  password: '',
  passwordError: false,
  passwordErrorText: 'should be at least 6 characters',
  error: null,
};

const ERROR_CODE_ACCOUNT_EXISTS =
  'auth/account-exists-with-different-credential';

const ERROR_MSG_ACCOUNT_EXISTS = `
  An account with an E-Mail address to
  this social account already exists. Try to login from
  this account instead and associate your social accounts on
  your personal account page.
`;

class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  handleInputChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState({ [name]: value });
  }

  onKeyDownInput = (event) => {
    const key = event.keyCode || event.charCode;
    if (key === 13) {
      if (this.validEmail() && this.validPassword()) {
        this.signIn();
      }
    }
  }

  validEmail = () => {
    if (/[a-zA-Z0-9._]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}/.test(this.state.email)) {
      this.setState({ emailErrorText: '' });
      this.setState({ emailError: false });
      return true;
    }

    this.setState({ emailErrorText: 'ex. email@sample.co' });
    this.setState({ emailError: true });
    return false;
  }

  validPassword = () => {
    if (this.isEmpty(this.state.password) || this.state.password.length < 6) {
      this.setState({ passwordErrorText: 'should be at least 6 characters' });
      this.setState({ passwordError: true });
      return false;
    }

    this.setState({ passwordErrorText: '' });
    this.setState({ passwordError: false });
    return true;
  }

  isEmpty = (str) => (!str || !str.trim() || str.length === 0);

  signIn = () => {
    const { email, password } = this.state;

    if (this.validEmail() && this.validPassword()) {
      this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.AVAILABILITY);
      })
      .catch(error => {
        this.setState({ error });
      });
    }

  };

  render() {

    return (
      <CardContent>
        <form className="Form-Container" noValidate autoComplete="off">
          <TextField
            ref={this.email}
            className="Text-Field"
            error={this.state.emailError}
            type="email"
            name="email"
            label="Email"
            value={this.state.email}
            onChange={this.handleInputChange}
            onKeyDown={this.onKeyDownInput}
            autoComplete="email"
            autoFocus
            required
            margin="normal"
          />
          {this.state.emailError && <FormHelperText className="Text-Field-Error" error>{this.state.emailErrorText}</FormHelperText>}

          <TextField
            ref={this.password}
            className="Text-Field"
            error={this.state.passwordError}
            type="password"
            name="password"
            label="Password"
            value={this.state.password}
            onChange={this.handleInputChange}
            onKeyDown={this.onKeyDownInput}
            autoComplete="current-password"
            required
            margin="normal"
          />
          {this.state.passwordError && <FormHelperText className="Text-Field-Error" error>{this.state.passwordErrorText}</FormHelperText>}
          {this.state.error && <FormHelperText className="Text-Field-Error" error>{this.state.error.message}</FormHelperText>}

          <Button variant="contained" size="medium" color="primary" className="Submit-Button" onClick={() => this.signIn()}>
            Login
          </Button>
        </form>
        <Link style={{ 'color': '#3e51b5', 'paddingTop': '3px', 'position': 'absolute', 'fontSize': 'small' }} to={ROUTES.PASSWORD_FORGET} className="menu-item"> Reset password</Link>
      </CardContent>
    );
  }
}

class SignInGoogleBase extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  onSubmit = () => {
    this.props.firebase
      .doSignInWithGoogle()
      .then(socialAuthUser => {
        // Create a user in your Firebase Realtime Database too
        return this.props.firebase.user(socialAuthUser.user.uid).set({
          username: socialAuthUser.user.displayName,
          email: socialAuthUser.user.email,
          roles: {},
        });
      })
      .then(() => {
        this.setState({ error: null });
        this.props.history.push(ROUTES.AVAILABILITY);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

  };

  render() {
    const { error } = this.state;

    return (
      <CardContent className="other-login">
        <form className="Form-Container">
          <Button variant="contained" size="medium" color="primary" className="Submit-Button" onClick={() => this.onSubmit()}>
            Sign In with Google
          </Button>

          {error && <p>{error.message}</p>}
        </form>
      </CardContent>
    );
  }
}

class SignInFacebookBase extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  onSubmit = () => {
    this.props.firebase
      .doSignInWithFacebook()
      .then(socialAuthUser => {
        // Create a user in your Firebase Realtime Database too
        return this.props.firebase.user(socialAuthUser.user.uid).set({
          username: socialAuthUser.additionalUserInfo.profile.name,
          email: socialAuthUser.additionalUserInfo.profile.email,
          roles: {},
        });
      })
      .then(() => {
        this.setState({ error: null });
        this.props.history.push(ROUTES.AVAILABILITY);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

  };

  render() {
    const { error } = this.state;

    return (
      <CardContent className="other-login">
        <form className="Form-Container">
          <Button variant="contained" size="medium" color="primary" className="Submit-Button" onClick={() => this.onSubmit()}>
            Sign In with Facebook
          </Button>

          {error && <p>{error.message}</p>}
        </form>
      </CardContent>
    );
  }
}

class SignInTwitterBase extends Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  onSubmit = () => {
    this.props.firebase
      .doSignInWithTwitter()
      .then(socialAuthUser => {
        // Create a user in your Firebase Realtime Database too
        return this.props.firebase.user(socialAuthUser.user.uid).set({
          username: socialAuthUser.additionalUserInfo.profile.name,
          email: socialAuthUser.additionalUserInfo.profile.email,
          roles: {},
        });
      })
      .then(() => {
        this.setState({ error: null });
        this.props.history.push(ROUTES.AVAILABILITY);
      })
      .catch(error => {
        if (error.code === ERROR_CODE_ACCOUNT_EXISTS) {
          error.message = ERROR_MSG_ACCOUNT_EXISTS;
        }

        this.setState({ error });
      });

  };

  render() {
    const { error } = this.state;

    return (
      <CardContent className="other-login">
        <form className="Form-Container">
          <Button variant="contained" size="medium" color="primary" className="Submit-Button" onClick={() => this.onSubmit()}>
            Sign In with Twitter
          </Button>

          {error && <p>{error.message}</p>}
        </form>
      </CardContent>
    );
  }
}

const SignInForm = compose(
  withRouter,
  withFirebase,
)(SignInFormBase);

const SignInGoogle = compose(
  withRouter,
  withFirebase,
)(SignInGoogleBase);

const SignInFacebook = compose(
  withRouter,
  withFirebase,
)(SignInFacebookBase);

const SignInTwitter = compose(
  withRouter,
  withFirebase,
)(SignInTwitterBase);

export default SignInPage;

export { SignInForm, SignInGoogle, SignInFacebook, SignInTwitter };
